



  <button *ngIf="notification" (click)="gotoReleaseNotes()" mat-button color="accent"
          class="px-1">
    Go to What's New
  </button>
